import { weatherStatus } from "../../pages/PlanOperationPage/Plan/Calendar/Operations/constants";
import { TOperation2 } from "../../util/varibles/interface";
import styles from './style.module.scss';


interface IProps {
    visible?: boolean
    operation: TOperation2
    mode?: 'default' | 'icon-only'
}

const getWeatherName = (operation: TOperation2) => {
    const { typical_condition = null } = operation;

    if (typical_condition === null) return null;

    return weatherStatus[typical_condition].name;
}

const Weather = ({ visible = true, operation, mode = 'default' }: IProps) => {
    const { typical_condition = null } = operation;

    if (!visible || typical_condition === null) return null;

    return <div
        className={[styles.weather, mode === 'icon-only' ? '!order-none !ml-0' : ''].join(' ')}
        data-weather-type={typical_condition}
        data-mode={mode}
        title={weatherStatus[typical_condition].name}
    />
}

export const WeatherFull = ({ visible = true, operation }: IProps) => {
    const weatherName = getWeatherName(operation);

    if (!visible || weatherName === null) return null;

    return <div className='flex h-[24px] items-center gap-1'>
        <div className="mt-[2px]">
            <Weather operation={operation} mode="icon-only" />
        </div>
        <span className="text-[15px]">{weatherName}</span>
    </div>
}

export default Weather;
